import { AnnualReward, Message } from '@app/core/interfaces';
import * as annualReward from './annual-reward.actions';

export interface State {
    entities: AnnualReward;
    loaded: boolean;
    loading: boolean;
    errors: Message[];
}

const initialState: State = {
    entities: null,
    loaded: false,
    loading: false,
    errors: [],
};

export function reducer(state: State = initialState, action: annualReward.Actions): State {
    switch (action.type) {

        case annualReward.LOAD: {
            return {
                ...state,
                loading: true,
            };
        }

        case annualReward.LOAD_SUCCESS: {
            return {
                ...state,
                entities: action.payload.annualReward,
                loading: false,
                loaded: true,
            };
        }

        case annualReward.LOAD_ERROR: {
            return {
                ...state,
                errors: action.payload.errors,
                loading: false,
            };
        }

        default: {
            return state;
        }
    }
}

export const getEntities = (state: State) => state.entities;
export const getErrors = (state: State) => state.errors;
export const isLoading = (state: State) => state.loading;
export const isLoaded = (state: State) => state.loaded;
